import gql from 'graphql-tag';
import AdminProductCategoryAllDataFragment from '../fragments/AdminProductCategoryAllDataFragment';

export default gql`
mutation updateProductCategory (
    $id: ID!
    $name: String!
    $parent_id: Int
    $url_key: String!
    $content: String
    $is_enable: Boolean!
    $date_to: String
    $date_from: String
    $show_in_menu: Boolean!
    $before: Int,
    $after: Int,
    $keywords: String
    $description: String
    $is_promotion: Boolean!
    $promotion_place: PromotionPlace
    $is_homepage_prohibited: Boolean
    $products: [ID]
) {
    updateProductCategory (input: {
        id: $id,
        name: $name,
        parent_id: $parent_id,
        url_key: $url_key,
        content: $content,
        is_enable: $is_enable,
        date_to: $date_to,
        date_from: $date_from,
        show_in_menu: $show_in_menu,
        before: $before,
        after: $after,
        keywords: $keywords,
        description: $description,
        is_promotion: $is_promotion
        promotion_place: $promotion_place
        is_homepage_prohibited: $is_homepage_prohibited
        products: $products

    }) {
        ...AdminProductCategoryAllDataFragment
    }
}
${AdminProductCategoryAllDataFragment}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/updateProductCategory.ts